// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".background-failure[data-v-140d62f2] {\n  background-color: #f0f0f0;\n  border-radius: 50%;\n  width: 250px;\n  height: 250px;\n}\n.theme--light.v-data-table thead tr th[data-v-140d62f2] {\n  background-color: #f4f4f4 !important;\n}\n.v-stepper__step__step[data-v-140d62f2] {\n  width: 26px;\n  height: 26px;\n}", ""]);
// Exports
module.exports = exports;
